import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied({ message = 'You do not have permission to access this page.' }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Access denied
      </Typography>
      <Typography color="text.secondary" align="center">
        {message}
      </Typography>
      <Button variant="contained" onClick={() => navigate('/admin-dashboard', { replace: true })}>
        Back to dashboard
      </Button>
    </Box>
  );
}
